<section class="hero">
  <div class="hero-body">
<p class="is-size-1">Indicadores de Calidad</p>
<img src="https://cacti.noctelecom.net/cacti/graph_image.php?local_graph_id=119">
<!-- Haga Click <a href="http://45.233.100.101/cacti/graph_image.php?local_graph_id=119">aquí</a> para ver los indicadores de calidad. -->
</div>
</section>
